import { useState } from 'react';
import { resolveMediaPath } from '@/shared/libs/resolve-media-path';
import { MOBILE_ICON_OVERRIDES } from '@/entities/minibanner/model/mobile-icon-overrides';
import { CROWN_IMAGE_URL } from '@/entities/minibanner/model/hooks';
import type { BannerData } from '@/entities/minibanner/model/bannerHelper';

const MiniBannerIcon = ({ banner }: { banner: BannerData }) => {
  const [webpFailed, setWebpFailed] = useState(false);
  const mobileIcon = MOBILE_ICON_OVERRIDES[banner.id];
  const mobileIconWebp = mobileIcon?.replace(/\.png$/, '.webp');
  const hasWebpVariant = !banner.image?.startsWith(CROWN_IMAGE_URL);
  const defaultIconWebp = hasWebpVariant
    ? banner.image?.replace(/\.png$/, '.webp')
    : undefined;

  return (
    <picture style={{ width: '100%', height: '100%', display: 'block' }}>
      {!webpFailed && mobileIconWebp && (
        <source
          media="(max-width: 768px)"
          srcSet={resolveMediaPath(mobileIconWebp)}
          type="image/webp"
        />
      )}
      {mobileIcon && (
        <source
          media="(max-width: 768px)"
          srcSet={resolveMediaPath(mobileIcon)}
        />
      )}
      {!webpFailed && defaultIconWebp && (
        <source
          srcSet={resolveMediaPath(defaultIconWebp)}
          type="image/webp"
        />
      )}
      <img
        src={resolveMediaPath(banner.image)}
        alt=""
        style={{ width: '100%', height: '100%', objectFit: 'contain' }}
        loading="lazy"
        onError={() => setWebpFailed(true)}
      />
    </picture>
  );
};

export { MiniBannerIcon };
